'use client'

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html lang="ko">
      <body>
        <div
          style={{
            display: 'flex',
            minHeight: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 16,
            fontFamily: 'system-ui, sans-serif',
          }}
        >
          <div style={{ textAlign: 'center', maxWidth: 320 }}>
            <h1 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>
              문제가 발생했어요
            </h1>
            <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 16 }}>
              일시적인 오류예요. 다시 시도해 주세요.
            </p>
            <button
              onClick={() => reset()}
              style={{
                width: '100%',
                padding: '10px 16px',
                borderRadius: 8,
                border: 'none',
                background: '#111827',
                color: '#fff',
                fontSize: 14,
                cursor: 'pointer',
              }}
            >
              다시 시도
            </button>
          </div>
        </div>
      </body>
    </html>
  )
}
